import { Nullable } from '@/utils/customtypes.util';
import SerializableObject from '@/utils/models/serializableobject.model';

export class PlaceResponse extends SerializableObject {
  OrderTrackingUrl: Nullable<string>;
}
